/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBlocks.defs.js'
export * as $defs from './getBlocks.defs.js'
